module.exports = __webpack_public_path__ + "static/media/verified.020a2f43.svg";